import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

interface IProps {
  isOpen: boolean;
  onClick?(): void;
  children: React.ReactNode;
}

const StyledContent = styled.div<IProps>`
  position: fixed;
  top: 0;
  left: 0;
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isOpen ? "flex" : "none")
  };
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${withVar(DesignToken.SurfaceOtherOverlay)};
  z-index: ${StackingContextLevel.FullOverlay};
`;

export const ModalPresenter: React.FC<IProps> = ({ isOpen, onClick, children }) => (
  <StyledContent isOpen={isOpen} onClick={onClick}>
    {children}
  </StyledContent>
);
